import { render, staticRenderFns } from "./ViewCricketPredictions.vue?vue&type=template&id=11080de4&scoped=true&"
import script from "./ViewCricketPredictions.vue?vue&type=script&lang=js&"
export * from "./ViewCricketPredictions.vue?vue&type=script&lang=js&"
import style0 from "./ViewCricketPredictions.vue?vue&type=style&index=0&id=11080de4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11080de4",
  null
  
)

export default component.exports